import React, { FunctionComponent } from "react"
import Grid from "../../components/Grid/Grid"
import LinkItem from "../../components/Grid/LinkItem"
import Loader from "../../components/Loader/Loader"
import Pagination from "../../components/Pagination/Pagination"
import Seo from "../../components/Seo/Seo"
import { iArtifact, iArtifactQuery } from "../../definitions/Artifacts"
import { useData } from "../../hooks/useData"
import ArtifactsFilters from "./Filters"
import ArtifactItem from "./Item"

const Artifacts: FunctionComponent = () => {
  const { loading, data, total, setQuery, query } = useData<
    iArtifactQuery,
    iArtifact
  >({
    link: "/v1/artifacts",
    defaultQuery: {},
    shouldPushQuery: true,
  })

  return (
    <>
      <Seo title={"Artifacts"} />
      <div className="content">
        <div className="content-header">
          <h1>Artifacts ({total})</h1>
          <ArtifactsFilters query={query} setQuery={setQuery} />
        </div>
        {loading ? (
          <Loader />
        ) : data.length ? (
          <div className="grid-wrap">
            <Grid>
              {data.map((d, i) => (
                <LinkItem key={i} url={"/artifacts/" + d.url}>
                  <ArtifactItem {...d} />
                </LinkItem>
              ))}
            </Grid>
          </div>
        ) : (
          <div className="no-data">No matching results.</div>
        )}
        <Pagination total={total} limit={50} setQuery={setQuery} />
      </div>
    </>
  )
}

export default Artifacts
